import { Box } from '@usap/uicomponents'
import styled from 'styled-components'

const FaqBox = styled(Box)`
  line-height: 23px;
  h4 {
    color: #323232;
    margin-left: 0.5rem;
    font-weight: normal;
  }

  .faq {
    border: 2px solid #f0f0f0;
    border-radius: 3px;
    padding: 1.2rem;
    display: block;
    margin: 6px;
    position: relative;
  }

  .faq > .faq-content {
    text-align: left;
    color: #323232;
  }

  .faq > label {
    font-weight: bold;
    outline: none;
    cursor: pointer;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    list-style: none;
    margin: 0 32px;
    display: block;
  }

  .faq > .arrow {
    position: absolute;
    right: 16px;
    top: 16px;
    display: block;
    transform: rotate(0deg);
  }

  .faq > label > .tabIcon {
    position: absolute;
    left: 16px;
    top: 16px;
    display: block;
  }

  .faq > .faq-toggler {
    display: none;
  }

  .faq > .faq-toggler ~ .faq-content {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: all 0.2s ease-in-out;
  }

  .faq > .faq-toggler:checked ~ .faq-content {
    max-height: 1000px;
    opacity: 1;
    padding: 0.5rem 2rem;
  }

  .faq > .faq-toggler:checked ~ .arrow {
    color: red;
    top: 16px;
    transform: rotate(180deg);
  }
`

export default FaqBox
